import { useContext, useEffect, useState } from "react"
import { getSpecificReturnProduct } from "../../../actions/returnProductAction"
import { useParams } from "react-router-dom"
import { ReturnStatee } from "./context/returnContext"

export default function Dates({ selectedPrinter }) {
  const [invoicedata, setInvoicedata] = useState()
  const [loading, setLoading] = useState(false)
  const params = useParams()

  // Use context for modal, fallback to params for direct page access
  const { returnId } = useContext(ReturnStatee) || {}
  const currentId = returnId || params.id

  useEffect(() => {
    if (currentId) {
      getspecificDataforInvoice()
    }
  }, [currentId])

  const getspecificDataforInvoice = async () => {
    if (!currentId) return

    const result = await getSpecificReturnProduct(currentId)
    setInvoicedata(result?.data)
    setLoading(true)
  }

  return (
    <>
      {loading ? (
        <>
          <div style={{ margin: "20px" }} className="mainDiv">
            <div className="DatesFirstDiv">
              <div className="firstDiv">
                <h5 style={{ fontFamily: "Calibri" }}>Customer Name:</h5>
                <p>{invoicedata?.customerName}</p>
              </div>
              <div className="secondDiv">
                <h5 style={{ fontFamily: "Calibri" }}>Cell No:</h5>
                <p>{invoicedata?.customerNumber}</p>
              </div>
            </div>
            <div className="DatesFirstDiv">
              <div className="firstDiv">
                <h5 style={{ fontFamily: "Calibri" }}>Generated By:</h5>
                <p> {invoicedata?.returnBy}</p>
              </div>
              <div className="secondDiv">
                <h5 style={{ fontFamily: "Calibri" }}>FBR Invoicer Number:</h5>
                <p> {invoicedata?.invoiceNumber}</p>
              </div>
            </div>
            <div className="DatesFirstDiv">
              <div className="firstDiv">
                <h5>Invoice date:</h5>
                <p> {new Date(invoicedata?.createdAt).toLocaleDateString("en-GB")}</p>
              </div>

              <>
                <div className="secondDiv">
                  <h5>Invoicer number:</h5>

                  <p> {invoicedata?.id}</p>
                </div>
              </>
            </div>
          </div>
        </>
      ) : (
        <h1></h1>
      )}
    </>
  )
}
